<!--
 * @Description: 收入明细dlg
 * @Author: gaohc
 * @Date: 2024-06-15 21:01:21
-->
<template>
      <el-dialog class="income-details-dialog" width="1200px" title="收入明细"
      :visible.sync="visible" :close-on-click-modal="false" @open="initData"
      :before-close="handleCancel" center>
      <div slot="title" class="header">
        <span class="title">收入明细</span>
        <span class="sub-title">{{title}}</span>
      </div>
      <div class="dialog-body">
        <el-row style="margin: 5px 30px 30px 30px">
          <el-col :span="7" style="text-align: left">
            <span class="search-title">订单编号：</span>
            <el-input v-model="filterParams.orderNo" size="small" clearable
              style="width: 187px" placeholder="请输入订单编号">
            </el-input>
          </el-col>
          <el-col :span="7" style="text-align: center" v-if="incomeItem.ownerType != 3">
            <span class="search-title">服务医院：</span>
            <el-select v-model="filterParams.hospitalId" clearable filterable size="small"
            :filter-method="(value) => commonUtil.handleListFilter(value, 'hospitalList',
              srcHospitalList, this)"
            @visible-change="(visible) => commonUtil.handleListFilterVisibleChange(visible,
              'hospitalList', srcHospitalList, this)"
            placeholder="请输入/选择" style="width: 187px">
            <el-option v-for="item in hospitalList" :key="item.id"
              :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          </el-col>
          <el-col :span="7" style="text-align: center">
            <span class="search-title">状态：</span>
            <el-select v-model="filterParams.status" size="small" filterable
              clearable style="width: 187px" placeholder="请输入/选择">
              <el-option v-for="(item, index) in statusList" :key="index"
                :label="item.value" :value="item.key * 1">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="incomeItem.ownerType == 3 ? 10 : 3" style="text-align: right">
            <el-button size="small" @click="handleQuery" type="primary" icon="el-icon-search">
              搜 索
            </el-button>
          </el-col>
        </el-row>
        <div style="margin: 0 30px;">
          <el-table style="border: 1px solid #f0f0f0"
          :data="dataTable" :header-cell-style="{ 'text-align': 'left', 'background-color': '#EFF5FA'}">
            <el-table-column label="收入金额" min-width="13%" align="left" 
              :sortable="true" :sort-method="sortMethod">
              <template slot-scope="scope"> 
                {{scope.row.incomeAmountYuan ? scope.row.incomeAmountYuan : '- -'}}
              </template>
            </el-table-column>
            <el-table-column prop="sharingIncomeDateTime" label="完成分账时间" min-width="10%" align="left">
              <template slot-scope="scope"> 
                {{scope.row.sharingIncomeDateTime ? scope.row.sharingIncomeDateTime : '- -'}}
              </template>
            </el-table-column>
            <el-table-column label="申请分账人" min-width="10%" align="left">
              <template slot-scope="scope">
                <span class="overflow-text-style">
                  {{scope.row.applySharingAccountPerson ? scope.row.applySharingAccountPerson : '- -'}}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="订单编号" min-width="15%" align="left">
              <template slot-scope="scope">
                <span class="overflow-text-style">
                  {{ scope.row.orderNo ? scope.row.orderNo : "- -" }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="服务医院" min-width="10%" align="left">
              <template slot-scope="scope">
                <span class="overflow-text-style">
                  {{scope.row.hospitalName ? scope.row.hospitalName : '- -'}}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="服务名称" min-width="10%" align="left">
              <template slot-scope="scope">
                <span class="overflow-text-style">
                  {{scope.row.hserviceName ? scope.row.hserviceName : '- -'}}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="订单实付金额 (元)" :sortable="true" 
              :sort-method="sortMethodPaymentAmount"
              min-width="15%" align="left" prop="totalAmountYuan">
              <template slot-scope="scope">
                {{ scope.row.paymentAmount ? scope.row.paymentAmount : "- -" }}
              </template>
            </el-table-column>
            <el-table-column label="退款金额 (元)" :sortable="true" 
              :sort-method="sortMethodRefundAmount"
              min-width="14%" align="left" prop="totalAmountYuan">
              <template slot-scope="scope">
                {{ scope.row.refundAmount ? scope.row.refundAmount : "- -" }}
              </template>
            </el-table-column>
            <el-table-column label="状态" min-width="6%" align="left">
              <template slot-scope="scope">
                {{ scope.row.statusTxt }}
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-row class="foot-pagination">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurPage"
            :current-page="filterParams.page" :page-sizes="pageSizes" :page-size="filterParams.pageSize"
            layout="total,prev, pager, next,sizes,jumper" :total="totalNumber"/>
        </el-row>
      </div>
      <div class="dialog-footer bk-wizard-bottons">
        <el-button @click="handleCancel">关 闭</el-button>
      </div>
    </el-dialog>
</template>

<script>
import Constant from "@/global/Constant.js";

export default {
  name: 'IncomeDetails',

  props: ['visible', 'incomeItem', 'begDate', 'endDate'],

  data() {
    return {
      title: '',
      hospitalList: [],
      srcHospitalList: [],
      statusList: [],

      dataTable: [],
      filterParams: {
        orderNo: '',
        hospitalId: '',
        status: '',
        page: 1,
        pageSize: this.commonConst.PAGE_SIZE,
      },
      pageSizes: this.commonConst.PAGE_SIZES,
      totalNumber: 0,
    }
  },

  methods: {
    handleCancel() {
      this.filterParams.orderNo = '';
      this.filterParams.hospitalId = '';
      this.filterParams.status = '';
      this.filterParams.begDate = '';
      this.filterParams.endDate = '';
      this.filterParams.institutionId = '';  
      this.filterParams.page = 1;
      this.$emit("close-dialog", false);
    },

    //以下是分页控件操作
    handleSizeChange(val) {
      this.filterParams.pageSize = val;
      this.pageIncomeDetails();
    },

    handleCurPage(curPage) {
      this.filterParams.page = curPage;
      this.pageIncomeDetails();
    },

    //总金额排序
    sortMethod(a, b) {
      return a.incomeAmountYuan * 1 > b.incomeAmountYuan * 1 ? -1 : 1;
    },

    sortMethodPaymentAmount(a, b) {
      return a.paymentAmount * 1 > b.paymentAmount * 1 ? -1 : 1;
    },

    sortMethodRefundAmount(a, b) {
      return a.refundAmount * 1 > b.refundAmount * 1 ? -1 : 1;
    },

    handleQuery() {
      this.filterParams.page = 1;
      this.pageIncomeDetails();
    },

    pageIncomeDetails() {
      console.log(this.commonConst.CNTYPE_URLENCODED)
      let params = this.filterParams;
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_PAGE_INCOME_REPORT_DETAILS,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED
      };
      this.vueRequest(requestData).then(result => {
        if (result != null) {
          this.dataTable = result.data || [];
          this.totalNumber = result.totalNumber || 0;
        }
      });
    },

    getFilterDo(instId) {
      return new Promise((resolve) => {
        let params = {institutionId: instId};
        let header = this.encryptionUtil.signatureParams(params,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_GET_INCOME_DETAILS_FILTER_DO,
          param: params,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.hospitalList = result.data.hospitalList;
            this.srcHospitalList = result.data.hospitalList;
            this.statusList = this.commonUtil.map2List(result.data.statusMap)
            resolve();
          }
        });
      });
    },

    async initData() {
      let item = this.incomeItem;
      this.filterParams.ownerType = item.ownerType;
      this.filterParams.begDate = this.begDate;
      this.filterParams.endDate = this.endDate;
      let instId = '';
      this.hospitalId = '';
      if (item.ownerType == 1) {
        instId = item.institutionId;
        this.title = item.institutionName;
        this.filterParams.ownerId = item.institutionId;
      } else if (item.ownerType == 2) {
        this.title = item.hospitalName;
        instId = item.institutionId;
        this.filterParams.hospitalId = item.hospitalId;
        this.filterParams.institutionId = item.institutionId;
        this.filterParams.ownerId = item.hospitalId;
      } else {
        this.title = item.incomePersonText;
        this.filterParams.ownerId= item.attendantId;
      }
      await this.getFilterDo(instId);
      this.pageIncomeDetails();
    }
  }
}
</script>
<style scoped>
.header {
  font-size: 15px;
  color: #5B5B5B;
  display: flex;
  align-items: center;
}
.title {
  font-weight: 600;
}
.sub-title {
  font-weight: 400;
  margin-left: 10px;
}
.dialog-footer {
  text-align: center;
}
.search-title {
  display: inline-block;
  min-width: 60px;
  text-align: right;
  color: #657180;
  font-size: 14px;
}
.foot-pagination {
  margin-top: 30px;
  text-align: right;
  right: 22px;
  border: solid 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/report/components/IncomeDetails.vue